import Inputmask from 'inputmask';

const masks = {
	ru: { mask: '+7 (999) 999-99-99', initial: '+7 (' },
	bel: { mask: '+375 (99) 999-99-99', initial: '+375: (' }, 
};

const maskSettings = {
	showMaskOnHover: false,
	showMaskOnFocus: false,
	inputmode: 'tel',
};

const isFirstChar = (value, data) => (
	((value === data || value === `+${data}`) && (data === '3' || data === '7' || data === '8' || data === '9'))
); 

const getMask = (num) => {
	if (num.match(/[789]/)) return masks.ru;
	else if (num.match(/3/)) return masks.bel;
};

const setMaskByLength = (string, input) => {
	let firstNum;
	const trimmedString = string.replace(/(\(|\)|\+| |-)+/g, '');
	if (trimmedString.length === 11) firstNum = '7';
	else if (input.value.length === 12) firstNum = '3';
	if (firstNum) {
		const mask = getMask(firstNum);
		Inputmask(mask.mask, maskSettings).mask(input);
		Inputmask.setValue(input, string);
	} else {
		input.value = '';
	}
};

const setMaskByFirstNumbers = (data, input) => {
	let firstNum;
	if (data.match(/^(8|\+?7|9)/)) firstNum = '7';
	else if (data.match(/^\+?375/)) firstNum = '3';
	const mask = getMask(firstNum);
	if (mask) {
		Inputmask(mask.mask, maskSettings).mask(input);
		data = sliceCode(data);
		Inputmask.setValue(input, data);
	} 
};

const handleInput = ({ target, data }) => {
	if (!target.inputmask) {
		if (isFirstChar(target.value, data)) {
			const mask = getMask(data);
			const value = data !== '9' ? mask.initial : `${mask.initial}${data}`;
			Inputmask(mask.mask, maskSettings).mask(target);
			Inputmask.setValue(target, value);
		}
		else if (target.value.length > 8) setMaskByLength(target.value, target);
		else if (target.value.slice(0, 1) === '+') target.value = target.value.slice(0, 1);
		else if (target.value === data && data === '+' || data === undefined) return;
		else target.value = '';
	}
};

const sliceCode = (string) => {
	if (string.match(/^[78]/)) return `${string.substring(1)}`;
	else if (string.match(/^\+7|^\+8/)) return `${string.substring(2)}`;
	else if (string.match(/^375/)) return `${string.substring(3)}`;
	else if (string.match(/^\+375/)) return `${string.substring(4)}`;
	return string;
};

const handleBackspaceKeydown = ({ target, code }) => {
	if (code === 'Backspace' && target.inputmask?.unmaskedvalue() === '') target.inputmask.remove();
};

const handlePaste = (event) => {
	event.preventDefault();
	const { target, clipboardData } = event;
	const data = clipboardData.getData('text/plain');
	setMaskByFirstNumbers(data, target);
};

const initMaskOnLoad = (input) => {
	if (input.value.match(/^(8|\+?7|9)/) || input.value.match(/^\+?375/)) setMaskByFirstNumbers(input.value, input);
	else setMaskByLength(input.value, input);
};

const setTelMask = (input) => {
	if (!input.inputmask && input.value && input.value.length > 8) initMaskOnLoad(input);
	input.addEventListener('input', handleInput);
	input.addEventListener('keydown', handleBackspaceKeydown);
	input.addEventListener('paste', handlePaste);
};

export function useAppendMask($element: HTMLInputElement): void {
	const mask: string = $element.dataset.mask;

	switch (mask) {
		case 'date':
			Inputmask('datetime', {
				placeholder: '__.__.____',
				inputFormat: 'dd.mm.yyyy',
			}).mask($element);
			break;

		case 'datetime':
			Inputmask('datetime', {
				placeholder: '__.__.____ __:__',
				inputFormat: 'dd.mm.yyyy HH:MM',
			}).mask($element);
			break;

		case 'tel':
			setTelMask($element);
			break;

		case 'code':
			Inputmask('999999', {
				placeholder: '______',
			}).mask($element);
			break;

		default:
			Inputmask({
				mask,
				showMaskOnHover: false,
				showMaskOnFocus: false,
				jitMasking: true,
				placeholder: '',
				inputmode: 'numeric',
			}).mask($element);
			break;
	}
}
